import ThemeColors from '@/styles/colors'

const pick = (...values) => values.find((v) => v !== undefined && v !== null && v !== '')

const echartsColors = {
    // Generic series colors
    series: {
        primary: pick(ThemeColors.quaternary, ThemeColors.primary),
        secondary: pick(ThemeColors.fifth, ThemeColors.quaternary),
        tertiary: pick(ThemeColors.secondary, ThemeColors.primary),
    },

    // Semantic colors for commonly repeated chart types
    bar: {
        fill: pick(ThemeColors.quaternary, ThemeColors.primary),
    },

    line: {
        stroke: pick(ThemeColors.fifth, ThemeColors.secondary),
    },

    // Heatmap gradients (explicitly set to avoid relying on ECharts defaults)
    heatmap: {
        // Low -> High
        range: ['#fff36f', '#f63737'],
    },

    // Semantic colors that must preserve existing UI meaning.
    semantic: {
        sla: {
            good: {
                fill: '#40E196',
                border: '#00C383',
            },
            // Used in some distribution charts (keeps existing lighter shade)
            goodLight: {
                fill: '#7FFEA8',
                border: '#00C383',
            },
            // Used in duration prediction charts (keeps existing soft border shade)
            goodSoft: {
                fill: '#7FFEA8',
                border: '#04c48c',
            },
            warn: {
                fill: '#FFBB00',
                border: '#FF6400',
            },
            bad: {
                fill: '#FF8084',
                border: '#F40019',
            },
            // Used in some booster pie charts
            badAlt: {
                fill: '#fc7474',
            },
            // Used in duration prediction charts (keeps existing soft border shade)
            badSoft: {
                fill: '#ff8b90',
                border: '#fb2332',
            },
        },

        booster: {
            timeToMeet: {
                fill: '#438AC8',
                border: '#0b5b9e',
            },
        },
    },

    palette: {
        neutral: {
            black: '#000',
            white: '#fff',
        },
        blue: [ThemeColors.quaternary, '#84b6f4', '#c4dafa', '#023047', '#a9d3ff'],
        blueMid: ThemeColors.quaternary,
        blueSoft: ThemeColors.quaternary,
        greenAccent: ThemeColors.fifth,
    },
}

export default echartsColors
